import { useSelector } from 'react-redux';
import { EndpointKey } from '../../http/EndpointKey';
import { getEndpointRetries } from '../../store/http-responses/selectors';
import { getGTKMDataKeys } from '../../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useIsDataPointValid } from '../../hooks/useIsStepDataValid';
export const useIsFilteredGTKMDataValid = () => {
  const gtkmRetries = useSelector(state => getEndpointRetries(state, EndpointKey.GTKMCompanyInfo));
  let gtkmDataKeys = useSelector(getGTKMDataKeys);
  if (gtkmRetries === 1) {
    gtkmDataKeys = gtkmDataKeys.filter(key => key !== Data.CompanyDomain);
  }
  const isGTKMDataValid = useIsDataPointValid(gtkmDataKeys);
  return isGTKMDataValid;
};